import * as React from 'react'
import {withTranslation, WithTranslation} from 'react-i18next'

import _ from "lodash";

interface HighlightedProps extends WithTranslation {
    text: string
    highlight?: string
}

interface HighlightedState {
}

export function removeHtmlTags(str:string) {
    if ((str === null) || (str === ''))
        return str;

    // Regular expression to identify HTML tags in 
    // the input string. Replacing the identified 
    // HTML tag with a null string.
    str = str.replace(/\&nbsp;/g, ' ')
    return str.replace(/(<([^>]+)>)/ig, '');
}

function replaceBetween(original: string, what: string, start: number, end: number) {
    return original.substring(0, start) + what + original.substring(end);
};

class HighlightedText extends React.Component<HighlightedProps, HighlightedState> {
    constructor(props: HighlightedProps) {
        super(props);
        this.state = {
        }
    }

    public render() {
        if (this.props.highlight === undefined || !this.props.highlight.trim()) {
            return <span>{this.props.text}</span>
        }

       
        const regex = new RegExp(`(${_.escapeRegExp(this.props.highlight)})`, 'gi')
        const parts = this.props.text.split(regex)
        return (
            <span>
                {parts.filter(part => part).map((part, i) => (
                    regex.test(part) ? <mark style={{ backgroundColor: "#ffef00" }} key={i}>{part}</mark> : (part.length < 55) ? <span key={i}>{part}</span> : <span key={i} > {replaceBetween(part, " ... ", 24, part.length - 26)}</span>
                ))}
            </span>
        )
    }
}

export default withTranslation()(HighlightedText);